import Usage from './usage';

const Home = [
    ...Usage,
];

export default Home;
export {
    Usage,
};